import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated';

const REQUEST_ACCESS_MUTATION = gql(/** @complexity 2 */ `
  mutation RequestPostAccess($id: ID!) {
    requestPostAccess(id: $id) {
      id
    }
  }`);

interface UseRequestPostAccessOpts {
  postId: string;
}

const useRequestPostAccess = ({ postId }: UseRequestPostAccessOpts) => {
  const [requestAccess, { data, loading }] = useMutation(
    REQUEST_ACCESS_MUTATION,
    {
      variables: { id: postId },
    },
  );

  const hasRequestedAccess = data?.requestPostAccess != null;

  return {
    requestAccess,
    loading,
    hasRequestedAccess,
  };
};

export default useRequestPostAccess;
